const colors = {
	pink: '#ff055e',
	logoBg: '#212121',
	navBg: '#323232',
	hover: '#3c3c3c',

	black: '#0f0f0f',
	dgray: '#2a2a2a',
	lgray: '#232323',
	white: '#fff'
};

export default colors;
